import type { PrefetchContext } from 'src/shared/prefetch';

export async function prefetch(_context: PrefetchContext): Promise<void> {
	// do nothing for now
}
